import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Text } from '../..'
import LineScale from './LineScale'
import styles from './Loading.module.scss'

const LoadingPanel = () => (
  <div className={`content-main ${styles.sectionLoader}`}>
    <div className='notice'>
      <Text
        weight='light'
        size='xl'
        className={styles.headline}
        variant='neutralCool'
        variantCount='900'
      >
        <FormattedMessage
          id='Loading.card.headline'
          defaultMessage='Getting the latest data'
        />
      </Text>
      <LineScale className={styles.loader} />
    </div>
  </div>
)

export default LoadingPanel
